import { GET_WATER_CONNECTION_APPROVAL_DETAILS_ACTION_TYPE, GET_WATER_CONNECTION_APPROVAL_LIST_ACTION_TYPE, GET_WATER_CONNECTION_APPROVAL_EXPORT_DATA_ACTION_TYPE, UPDATE_WATER_CONNECTION_APPROVAL__ACTION_TYPE } from "../../../../utils/constants";


const initialState = [];

function waterConnectionApprovalReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_WATER_CONNECTION_APPROVAL_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case GET_WATER_CONNECTION_APPROVAL_LIST_ACTION_TYPE:
            return [...state, payload];
        case GET_WATER_CONNECTION_APPROVAL_EXPORT_DATA_ACTION_TYPE:
            return [...state, payload];
        case UPDATE_WATER_CONNECTION_APPROVAL__ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default waterConnectionApprovalReducer;